(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('followup-call', {
            parent: 'entity',
            url: '/followup-call?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.followupCall.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/followup-call/followup-calls.html',
                    controller: 'FollowupCallController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('followupCall');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('followup-call-detail', {
            parent: 'entity',
            url: '/followup-call/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.followupCall.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/followup-call/followup-call-detail.html',
                    controller: 'FollowupCallDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('followupCall');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FollowupCall', function($stateParams, FollowupCall) {
                    return FollowupCall.get({id : $stateParams.id});
                }]
            }
        })
        .state('followup-call.new', {
            parent: 'followup-call',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-call/followup-call-dialog.html',
                    controller: 'FollowupCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                date: null,
                                willTheyCall: null,
                                comments: null,
                                completed: null,
                                wentToAnotherRehubCenter: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('followup-call', null, { reload: true });
                }, function() {
                    $state.go('followup-call');
                });
            }]
        })
        .state('followup-call.edit', {
            parent: 'followup-call',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-call/followup-call-dialog.html',
                    controller: 'FollowupCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FollowupCall', function(FollowupCall) {
                            return FollowupCall.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('followup-call', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('followup-call.delete', {
            parent: 'followup-call',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-call/followup-call-delete-dialog.html',
                    controller: 'FollowupCallDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FollowupCall', function(FollowupCall) {
                            return FollowupCall.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('followup-call', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
